import { render, staticRenderFns } from "./FamilyPolicies.vue?vue&type=template&id=342f3aba&scoped=true"
import script from "./FamilyPolicies.vue?vue&type=script&lang=js"
export * from "./FamilyPolicies.vue?vue&type=script&lang=js"
import style0 from "./FamilyPolicies.vue?vue&type=style&index=0&id=342f3aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f3aba",
  null
  
)

export default component.exports